module.exports = __webpack_public_path__ + "static/img/jiaoshiewm.3a52ab9.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/jiaoshiewm.png
// module id = P9wN
// module chunks = 10